/** Neutral browser toolbar / mobile status-bar color (not stakeholder branding). */
export const NEUTRAL_BROWSER_THEME_COLOR = '#f5f5f5'

const THEME_COLOR_SELECTOR = 'meta[name="theme-color"]'

function ensureThemeColorMeta(): HTMLMetaElement {
  let meta = document.querySelector(THEME_COLOR_SELECTOR) as HTMLMetaElement | null
  if (!meta) {
    meta = document.createElement('meta')
    meta.name = 'theme-color'
    document.head.appendChild(meta)
  }
  return meta
}

/** Keep `<meta name="theme-color">` on the neutral shell color — never stakeholder tints. */
export function pinNeutralBrowserChromeTheme(): void {
  if (typeof document === 'undefined') return
  const meta = ensureThemeColorMeta()
  if (meta.content !== NEUTRAL_BROWSER_THEME_COLOR) {
    meta.content = NEUTRAL_BROWSER_THEME_COLOR
  }
  // Drop duplicate theme-color tags (only the first should win in browsers).
  const all = document.querySelectorAll(THEME_COLOR_SELECTOR)
  for (let i = 1; i < all.length; i += 1) {
    all[i]?.remove()
  }
}

let themeColorObserverStarted = false

/**
 * Re-pin neutral browser chrome if anything mutates `<meta name="theme-color">`.
 * Guards against the removed `useShellDocumentThemeColor` behavior and stale bundles.
 */
export function startBrowserChromeThemeLock(): void {
  if (typeof document === 'undefined' || themeColorObserverStarted) return
  themeColorObserverStarted = true
  pinNeutralBrowserChromeTheme()
  const head = document.head
  if (!head || typeof MutationObserver === 'undefined') return
  const observer = new MutationObserver(() => {
    pinNeutralBrowserChromeTheme()
  })
  observer.observe(head, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['content'],
  })
}
